
import { defineComponent } from 'vue'
import ExamMasterList from '@/components/block/ExamMasterList.vue'
import MasterHeader from '@/components/block/MasterHeader.vue'
import Pagination from '@/components/block/Pagination.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'
import { useTest } from '@/provider/test'

export default defineComponent({
  name: 'examMasterList',

  components: {
    ExamMasterList,
    MasterHeader,
    Pagination,
    HeadingLv3,
    Button
  },

  setup() {
    const { state } = useTest()
    return {
      state
    }
  }
})
